import CancelDeleteAccount from "../pages/delete-account/CancelDeleteAccount.jsx";

export const ROUTE_PATHS = {
  Home: "/",
  SignIn: "/sign-in",
  FindId: "/find-id",
  FindPassword: "/find-password",
  Review: "/review/*",
  EditReview: '/edit-review/*',
  ReviewAdditionalComment: "/review-additional-comment/*",
  PremiumIntro: "/premium-intro",
  VerifyCode: "/verify-code",
  FindIdResult: "/find-id-result",
  ChangePassword: "/change-password",
  EditInfo: "/edit-info",
  DeleteAccount: "/delete-account",
  AppConnect: "/app-connect",
  PremiumServiceManagement: "/premium-service-management",
  DeleteAccountDetails: "/delete-account-details",
  Representative: "/representative-authentication",
  DeleteReason: "/reason-of-deletion",
  TermAndPolicy: "/terms-and-policy",
  TermAndPolicyDetails: "/terms-and-policy/:id/:title",
  CardManage: "/card-manage",
  EditCardManage: "/edit-card-manage",
  ViewEditCardManage: "/view-edit-card-manage",
  HistoryPayment: "/history-payment",
  Notification: "/notification",
  Analytics: "/analytics",
  AnalyticsSelling: "/analytics/selling",
  AnalyticsFlag: "/analytics/flag",
  More: "/more",
  CancelDeleteAccount: "/cancel-delete-account",
  CancelPremiumDeleteRequest: "/cancel-premium-delete-request",
  ChangePasswordResult: "/change-password-result",
  NotFound:"*"
};
